import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";

export function useOrganizationMembersShallow(orgId: string | null | undefined) {
	/** Hooks */
	const { organization } = useAuth();

	/** Query */
	const { data: members = [] } = useQuery({
		queryKey: ["organization", orgId || "--", "members", "shallow"],
		queryFn: async () => {
			if (!orgId || !organization) throw new Error("Missing orgId");
			const response = await client.organizations[":orgId"].members.shallow.$get({
				param: { orgId },
			});
			const data = await responseHandler(response);
			return data.members;
		},
		enabled: !!orgId && !!organization,
	});

	return members;
}
